export const getEnv = () => {
    return process.env.REACT_APP_ENV || 'local';
};

export const isLocal = () => getEnv() === 'local';

export const isTest = () => getEnv() === 'test';

export const isProd = () => getEnv() === 'prod';

export const isDebug = () => process.env.REACT_APP_DEBUG_LOGGING === "true";